import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";

// internal imports
import ComponentCustomModal from "../../../components/common/customModal/ComponentCustomModal";
import { FtextField } from "../../../components/common/FtextField";
import { badge } from "../../../components/common/Utils";
import { informationEnBn } from "../../../components/common/tooltipInformation/informationEnBn";
import { updatebKashIPNReference } from "../../../features/apiCalls";
import Loader from "../../../components/common/Loader";
import { toast } from "react-toastify";

const IPNReferenceUpdate = ({ show, setShow, message }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  //---> Get customer from redux store
  const customers = useSelector((state) => state.customer.customer);

  // loading state
  const [isLoading, setIsLoading] = useState(false);

  // customer ipn payment reference id edit function
  const handleuUpdateIPNReference = (values) => {
    const customer = customers?.find(
      (user) => user.customerId === values?.reference
    );
    if (!customer) {
      toast.error(t("notFoundCustomer"));
    }

    const sendingData = {
      refId: values?.reference,
      amount: message?.amount,
      shunnoId: message?.shunnoId,
      messageId: message?.id,
    };

    // reference id update api
    updatebKashIPNReference(dispatch, sendingData, setIsLoading, setShow);
  };

  return (
    <ComponentCustomModal
      show={show}
      setShow={setShow}
      centered={true}
      size="md"
      header={t("editReferenceID")}
      footer={
        <div>
          <button type="submit" form="messageEdit" className="btn btn-primary">
            {isLoading ? <Loader /> : t("save")}
          </button>
        </div>
      }
    >
      <Formik
        initialValues={{ reference: message?.refId }}
        validationSchema={Yup.object({
          reference: Yup.string().required(t("required")),
        })}
        onSubmit={(values) => {
          handleuUpdateIPNReference(values);
        }}
        enableReinitialize
      >
        {() => (
          <Form id="messageEdit">
            <div className="mb-3">
              <span>{badge(message?.status)}</span>
              <p>{message?.message}</p>
            </div>

            <FtextField
              label={t("refNo")}
              name="reference"
              placeholder={t("customerId")}
              info={informationEnBn()?.[3]}
            />
          </Form>
        )}
      </Formik>
    </ComponentCustomModal>
  );
};

export default IPNReferenceUpdate;
